(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab_hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isRtl = (element) => getComputedStyle(element).direction === 'rtl';

    // Matches the 920px switch between the mobile and desktop layouts in the stylesheet
    const desktopLayout = () => window.matchMedia('(min-width: 920px)').matches;

    // Children may not exist yet if the script runs before the section is parsed
    const whenParsed = (callback) => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    };

    if (!customElements.get('hero-slider')) {
      class HeroSlider extends HTMLElement {
        connectedCallback() {
          whenParsed(() => this.init());
        }

        init() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          if (this.slides.length < 2 || this.ready) return;
          this.ready = true;

          let settings = {};
          try {
            settings = JSON.parse(this.dataset.sectionSettings || '{}');
          } catch (error) {
            settings = {};
          }

          this.track = this.querySelector('[data-track]');
          this.arrows = this.querySelector('[data-arrows]');
          this.toggleButton = this.querySelector('[data-toggle]');
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.prevButton = this.querySelector('[data-slide-prev]');
          this.nextButton = this.querySelector('[data-slide-next]');
          this.samples = new Map();
          this.index = 0;
          this.delay = Number(settings.cycleSpeed) || 7000;
          this.autoplay = settings.autoPlay === true;
          this.paused = reduceMotion();
          this.holds = new Set();
          this.timer = null;

          this.querySelector('[data-slide-prev]').addEventListener('click', () => this.goTo(this.index - 1));
          this.querySelector('[data-slide-next]').addEventListener('click', () => this.goTo(this.index + 1));
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

          this.resizeObserver = new ResizeObserver(() => this.positionControls());
          this.slides.forEach((slide) => {
            this.resizeObserver.observe(slide);
            const panel = slide.querySelector('.hero-slider__products');
            if (panel) this.resizeObserver.observe(panel);
          });
          this.arrows.hidden = false;

          if (this.toggleButton) {
            this.toggleButton.addEventListener('click', () => {
              this.paused = !this.paused;
              this.sync();
            });
          }

          if (this.autoplay) {
            this.addEventListener('mouseenter', () => this.hold('hover', true));
            this.addEventListener('mouseleave', () => this.hold('hover', false));
            this.addEventListener('focusin', () => this.hold('focus', true));
            this.addEventListener('focusout', (event) => {
              if (!this.contains(event.relatedTarget)) this.hold('focus', false);
            });
            this.onVisibility = () => this.hold('hidden', document.hidden);
            document.addEventListener('visibilitychange', this.onVisibility);
          }

          this.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.findIndex((slide) => slide.contains(event.target));
            if (index > -1) this.goTo(index);
            this.hold('editor', true);
          });
          this.addEventListener('shopify:block:deselect', () => this.hold('editor', false));

          this.bindSwipe();
          this.goTo(0);
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        }

        hold(reason, active) {
          active ? this.holds.add(reason) : this.holds.delete(reason);
          this.sync();
        }

        goTo(target) {
          const count = this.slides.length;
          this.index = (target + count) % count;
          this.track.style.setProperty('--hero-index', this.index);

          this.slides.forEach((slide, index) => {
            const active = index === this.index;
            slide.inert = !active;
            slide.classList.toggle('is-selected', active);
          });

          this.dots.forEach((dot, index) => {
            dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
          });

          this.positionControls();
          this.sync();
        }

        // Arrows centre on the banner; on mobile the dots sit just above the product slider
        positionControls() {
          const slide = this.slides[this.index];
          const media = slide.querySelector('.hero-slider__media');
          if (!media) return;

          let height = media.offsetHeight;
          const panel = slide.querySelector('.hero-slider__products');
          if (panel && !desktopLayout()) {
            height = Math.max(panel.getBoundingClientRect().top - media.getBoundingClientRect().top, 0);
          }

          const style = this.style;
          style.setProperty('--hero-media-top', `${media.offsetTop}px`);
          style.setProperty('--hero-media-left', `${media.offsetLeft}px`);
          style.setProperty('--hero-media-width', `${media.offsetWidth}px`);
          style.setProperty('--hero-media-height', `${height}px`);

          this.updateArrowTone();
        }

        /*
          Picks one colour for both arrows, based on the parts of the background image behind them.
          Both arrows always match: the colour chosen is the one with the better contrast at the weaker side.
          A slide can set light or dark arrows instead.
        */
        updateArrowTone() {
          if (!desktopLayout() || !this.prevButton || !this.nextButton) return;

          const slide = this.slides[this.index];
          const setting = slide.dataset.arrowStyle || 'auto';
          if (setting !== 'auto') {
            this.applyArrowTone(setting, setting);
            return;
          }

          this.loadSample(slide).then((sample) => {
            if (slide !== this.slides[this.index]) return;
            if (!sample) {
              this.applyArrowTone('light', 'light');
              return;
            }
            const media = slide.querySelector('.hero-slider__media');
            const behind = [this.luminanceBehind(sample, media, this.prevButton), this.luminanceBehind(sample, media, this.nextButton)];

            // Contrast ratios for white arrows and for dark (#1a1a1a) arrows, taking the weaker side of each
            const lightContrast = Math.min(...behind.map((l) => 1.05 / (l + 0.05)));
            const darkContrast = Math.min(...behind.map((l) => (l + 0.05) / 0.0603));
            const tone = darkContrast > lightContrast ? 'dark' : 'light';
            this.applyArrowTone(tone, tone);
          });
        }

        applyArrowTone(prev, next) {
          this.prevButton.classList.toggle('hero-slider__arrow--dark', prev === 'dark');
          this.nextButton.classList.toggle('hero-slider__arrow--dark', next === 'dark');
        }

        // A small copy of the background image, loaded once per slide
        loadSample(slide) {
          if (this.samples.has(slide)) return this.samples.get(slide);

          const image = slide.querySelector('img.hero-slider__background');
          const promise = new Promise((resolve) => {
            if (!image) {
              resolve(null);
              return;
            }

            const url = new URL(image.currentSrc || image.src, window.location.href);
            url.searchParams.set('width', '320');

            const probe = new Image();
            probe.crossOrigin = 'anonymous';
            probe.onload = () => {
              try {
                const canvas = document.createElement('canvas');
                canvas.width = probe.naturalWidth;
                canvas.height = probe.naturalHeight;
                const context = canvas.getContext('2d', { willReadFrequently: true });
                context.drawImage(probe, 0, 0);
                context.getImageData(0, 0, 1, 1);
                resolve({ context, width: canvas.width, height: canvas.height });
              } catch (error) {
                resolve(null);
              }
            };
            probe.onerror = () => resolve(null);
            probe.src = url.href;
          });

          this.samples.set(slide, promise);
          return promise;
        }

        // Works out where the button sits on the filled image and measures the brightness there
        luminanceBehind(sample, media, button) {
          const background = media.querySelector('.hero-slider__background');
          const width = media.clientWidth;
          const height = media.clientHeight;
          const scale = Math.max(width / sample.width, height / sample.height);

          const [positionX = '50%', positionY = '50%'] = getComputedStyle(background).objectPosition.split(' ');
          const offset = (value, spare) => (value.endsWith('%') ? (spare * parseFloat(value)) / 100 : parseFloat(value));
          const offsetX = offset(positionX, width - sample.width * scale);
          const offsetY = offset(positionY, height - sample.height * scale);

          const buttonBox = button.getBoundingClientRect();
          const areaBox = this.arrows.getBoundingClientRect();
          const size = Math.max(buttonBox.width, 44);
          const centreX = buttonBox.left - areaBox.left + buttonBox.width / 2;
          const centreY = buttonBox.top - areaBox.top + buttonBox.height / 2;

          const clamp = (value, max) => Math.min(Math.max(Math.round(value), 0), max);
          const x = clamp((centreX - size / 2 - offsetX) / scale, sample.width - 1);
          const y = clamp((centreY - size / 2 - offsetY) / scale, sample.height - 1);
          const w = Math.max(1, Math.min(Math.round(size / scale), sample.width - x));
          const h = Math.max(1, Math.min(Math.round(size / scale), sample.height - y));
          const pixels = sample.context.getImageData(x, y, w, h).data;

          const linear = (channel) => {
            const value = channel / 255;
            return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
          };

          let total = 0;
          for (let i = 0; i < pixels.length; i += 4) {
            total += 0.2126 * linear(pixels[i]) + 0.7152 * linear(pixels[i + 1]) + 0.0722 * linear(pixels[i + 2]);
          }
          return total / (pixels.length / 4);
        }

        sync() {
          clearTimeout(this.timer);
          const running = this.autoplay && !this.paused && this.holds.size === 0;

          this.track.setAttribute('aria-live', running ? 'off' : 'polite');

          if (this.toggleButton) {
            this.toggleButton.classList.toggle('is-paused', this.paused);
            this.toggleButton.setAttribute('aria-label', this.paused ? this.dataset.labelPlay : this.dataset.labelPause);
          }

          if (running) {
            this.timer = setTimeout(() => this.goTo(this.index + 1), this.delay);
          }
        }

        bindSwipe() {
          this.slides.forEach((slide) => {
            const area = slide.querySelector('[data-swipe]');
            if (!area) return;

            let startX = 0;
            let startY = 0;
            let tracking = false;
            let swiped = false;

            area.addEventListener('pointerdown', (event) => {
              if (event.pointerType === 'mouse' && event.button !== 0) return;
              tracking = true;
              swiped = false;
              startX = event.clientX;
              startY = event.clientY;
            });

            area.addEventListener('pointerup', (event) => {
              if (!tracking) return;
              tracking = false;

              const deltaX = event.clientX - startX;
              const deltaY = event.clientY - startY;
              if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

              swiped = true;
              const forward = (deltaX < 0) !== isRtl(this);
              this.goTo(this.index + (forward ? 1 : -1));
            });

            area.addEventListener('pointercancel', () => {
              tracking = false;
            });

            area.addEventListener('click', (event) => {
              if (!swiped) return;
              event.preventDefault();
              swiped = false;
            }, true);

            area.addEventListener('dragstart', (event) => event.preventDefault());
          });
        }
      }

      customElements.define('hero-slider', HeroSlider);
    }

    if (!customElements.get('hero-products')) {
      const MIN_CARD = 150;
      const MIN_CARD_DESKTOP = 160;
      const MIN_CARD_MEDIA = 48;
      const CAPPED = 'hero-slider__products--capped';
      const COMPACT = 'hero-slider__products--compact';

      class HeroProducts extends HTMLElement {
        connectedCallback() {
          whenParsed(() => this.init());
        }

        init() {
          if (this.ready) return;

          this.list = this.querySelector('[data-list]');
          this.row = this.list ? this.list.firstElementChild : null;
          this.nav = this.querySelector('[data-nav]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.panel = this.closest('.hero-slider__products');
          this.content = this.closest('.hero-slider__content');
          const slide = this.closest('.hero-slider__slide');
          this.media = slide ? slide.querySelector('.hero-slider__media') : null;
          if (!this.list || !this.row || !this.nav || !this.panel || !this.content || !this.media) return;
          this.ready = true;

          this.frame = null;
          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };

          this.list.addEventListener('scroll', this.onScroll, { passive: true });

          // Only one set of arrows shows at a time: the product slider's while it is hovered
          const slider = this.closest('hero-slider');
          if (slider) {
            this.panel.addEventListener('pointerenter', () => slider.classList.add('hero-slider--products-hover'));
            this.panel.addEventListener('pointerleave', () => slider.classList.remove('hero-slider--products-hover'));
          }

          this.prev.addEventListener('click', () => this.step(-1));
          this.next.addEventListener('click', () => this.step(1));

          this.resizeObserver = new ResizeObserver(() => this.schedule());
          this.resizeObserver.observe(this.row);
          this.resizeObserver.observe(this.content);

          this.fit();
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          if (this.fitFrame) cancelAnimationFrame(this.fitFrame);
        }

        schedule() {
          if (this.fitFrame) return;
          this.fitFrame = requestAnimationFrame(() => {
            this.fitFrame = null;
            this.fit();
            this.update();
          });
        }

        // As many products as fit at a readable card width, up to 4
        slotsFor(width, desktop) {
          if (!desktop) {
            const setting = this.dataset.mobileSlots;
            if (setting === '1' || setting === '2') return Number(setting);
          }
          const gutter = parseFloat(getComputedStyle(this.panel).getPropertyValue('--hero-panel-gutter')) || 15;
          const minCard = desktop ? MIN_CARD_DESKTOP : MIN_CARD;
          return Math.max(1, Math.min(4, Math.floor((width - gutter * 2) / minCard)));
        }

        /*
          Keeps the product slider within its space in the banner.
          Desktop: the slider fills the width beside the overlay. Card count follows that width,
          and when the banner is short the product images get shorter, then the heading makes way.
          Mobile: the slider may use up to half the banner height. Cards first narrow so the slider
          centres, then the same steps apply.
        */
        fit() {
          const panel = this.panel;
          const style = panel.style;
          const desktop = desktopLayout();

          panel.classList.remove(COMPACT);
          this.uncap();
          style.removeProperty('--hero-panel-width');
          style.removeProperty('--hero-card-size');

          const gutter = parseFloat(getComputedStyle(panel).getPropertyValue('--hero-panel-gutter')) || 15;
          const itemCount = this.row.children.length;
          const contentStyle = getComputedStyle(this.content);
          const contentHeight = this.content.clientHeight - parseFloat(contentStyle.paddingTop) - parseFloat(contentStyle.paddingBottom);
          const available = desktop ? contentHeight : Math.min(contentHeight, Math.floor(this.media.offsetHeight * 0.5));
          const maxWidth = panel.getBoundingClientRect().width;
          const maxSlots = this.slotsFor(maxWidth, desktop);
          const fits = () => panel.offsetHeight <= available;

          let width = 0;
          let visible = 1;
          const apply = (size) => {
            width = size;
            style.setProperty('--hero-card-size', `${size}px`);
            if (!desktop) style.setProperty('--hero-panel-width', `${Math.ceil(visible * size + gutter * 2)}px`);
          };

          // Cards share the full width, so fewer products than slots still fill the slider
          const attempt = (slots, compact, minImage) => {
            panel.classList.toggle(COMPACT, compact);
            this.uncap();
            visible = Math.max(1, Math.min(itemCount, slots));
            apply(Math.floor((maxWidth - gutter * 2) / visible));
            if (fits()) return true;
            this.cap(available, minImage);
            return fits();
          };

          if (!desktop) {
            visible = Math.max(1, Math.min(itemCount, maxSlots));
            apply(Math.floor((maxWidth - gutter * 2) / maxSlots));
            while (!fits() && width > MIN_CARD) apply(Math.max(MIN_CARD, width - 8));
            if (fits()) return;
          }

          // Keep at least 2 products before giving up the heading, and 1 only as a final step.
          // A fixed mobile product count is always respected.
          const fixedCount = !desktop && ['1', '2'].includes(this.dataset.mobileSlots);
          const passes = [[false, 72, 2], [true, 72, 2], [true, MIN_CARD_MEDIA, 1]];
          for (const [compact, minImage, fewest] of passes) {
            const lowest = fixedCount ? maxSlots : Math.min(fewest, maxSlots);
            for (let slots = maxSlots; slots >= lowest; slots -= 1) {
              if (attempt(slots, compact, minImage)) return;
            }
          }

          // Nothing fits cleanly: use the shortest arrangement
          let best = { slots: maxSlots, height: Infinity };
          for (let slots = maxSlots; slots >= 1; slots -= 1) {
            attempt(slots, true, MIN_CARD_MEDIA);
            if (panel.offsetHeight < best.height) best = { slots, height: panel.offsetHeight };
          }
          attempt(best.slots, true, MIN_CARD_MEDIA);
        }

        uncap() {
          this.panel.classList.remove(CAPPED);
          this.panel.style.removeProperty('--hero-card-media-height');
        }

        // Shortens the product images by exactly the amount the slider is over
        cap(available, minImage) {
          this.markCardMedia();
          this.uncap();

          const cardMedia = this.row.querySelector('.hero-slider__card-media');
          if (!cardMedia) return;

          const excess = this.panel.offsetHeight - available;
          if (excess <= 0) return;

          const target = Math.max(minImage, Math.floor(cardMedia.getBoundingClientRect().height - excess));
          this.panel.style.setProperty('--hero-card-media-height', `${target}px`);
          this.panel.classList.add(CAPPED);
        }

        // Finds each card's image wrapper without relying on the theme's class names
        markCardMedia() {
          Array.from(this.row.children).forEach((card) => {
            if (card.querySelector('.hero-slider__card-media')) return;
            const image = card.querySelector('img, svg');
            if (!image) return;

            // Climb to the largest wrapper that holds only imagery, stopping before any text
            let wrapper = image;
            while (wrapper.parentElement && wrapper.parentElement !== card && wrapper.parentElement.innerText.trim() === '') {
              wrapper = wrapper.parentElement;
            }
            if (wrapper !== image) wrapper.classList.add('hero-slider__card-media');
          });
        }

        step(direction) {
          const item = this.row.firstElementChild;
          const distance = item ? item.getBoundingClientRect().width : this.list.clientWidth;
          const sign = isRtl(this.list) ? -1 : 1;

          this.list.scrollBy({
            left: distance * direction * sign,
            behavior: reduceMotion() ? 'auto' : 'smooth'
          });
        }

        update() {
          const max = this.list.scrollWidth - this.list.clientWidth;
          const overflowing = max > 2;
          this.nav.hidden = !overflowing;
          if (!overflowing) return;

          const position = Math.abs(this.list.scrollLeft);
          this.prev.disabled = position <= 2;
          this.next.disabled = position >= max - 2;
        }
      }

      customElements.define('hero-products', HeroProducts);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
